import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import { chartFilter } from './dashboards/display/ChartFilter';
import { Auth } from 'aws-amplify';

const sdkInst = new ChartsEmbedSDK({
  baseUrl: process.env.REACT_APP_MONGO_CHARTS_BASE_URL,
  getUserToken: async () => {
    return await Auth.currentAuthenticatedUser()
      .then((user) => {
        return user.signInUserSession.accessToken['jwtToken'];
      })
      .catch((err) => console.log(err));
  },
});

export const getEmbedsdk = () => {
  return sdkInst;
};

export const createChart = (
  chartId,
  chartIdYear,
  chartHeight,
  chartWidth,
  showAttribution,
  refreshInterval,
  subFilterField,
  dateField,
  dateFilter,
  selectedSub,
  subFilter,
  subIdFilter
) => {
  let filter = chartFilter(
    dateField,
    subFilterField,
    subFilter,
    subIdFilter,
    selectedSub,
    dateFilter
  );

  return sdkInst.createChart({
    chartId:
      (dateFilter === 'yearly' || dateFilter === 'ytd') && chartIdYear
        ? chartIdYear
        : chartId,
    height: chartHeight ? chartHeight : 300,
    width: chartWidth ? chartWidth : 400,
    showAttribution: showAttribution ? showAttribution : false,
    refreshInterval: refreshInterval ? refreshInterval : 200,
    filter: filter,
  });
};
